import { api } from "@/plugins/api";

const state = {
  transactions: [],
};

const getters = {
  getAllTransactions: (state) => state.transactions,

  getTransactionById: (state) => (id) =>
    state.transactions.filter((transaction) => transaction.id === id),
};

const actions = {
  async fetchAllTransactions({ commit }) {
    try {
      const response = await api.get("/transactions");
      const transactions = response.data.data;
      console.log("transactions", transactions);
      commit("setTransactions", transactions);
      //return { status: response.status, msg: response.data.message };
      return true;
    } catch (error) {
      //return { status: error.response.status, msg: error.message };
      return false;
    }
  },
  async addWithdraw({ commit }, data) {
    try {
      console.log("data", data);
      console.log("data id", data.accountant_id);
      const response = await api.post(`/transactions`, {
        accountant_id: data.accountant_id,
        value: data.value,
      });
      console.log("response", response.data.data);
      commit("addWithdraw", response.data.data);
      return true;
    } catch (error) {
      return false;
    }
  },
};

const mutations = {
  setTransactions(state, transactions) {
    state.transactions = transactions;
    //console.log("mu", state.actions);
  },
  addWithdraw(state, withdraw) {
    console.log("withdraw:", withdraw);
    withdraw.actionDate = new Date(withdraw.transactionDate).toLocaleString();
    state.transactions.unshift(withdraw);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
